<template>
  <aside class="aside">
    <div class="aside__logo">
      <div class="img_circle">
        <img :src="user.photo" alt="" />
      </div>

      <h2>مرحبا {{ user.firstName }}</h2>
      <div class="dropdown">
        <button
          class="btn dropdown-toggle"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa fa-ellipsis-v"></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li class="dropdown-menu__head">
            <p>{{ user.firstName + " " + user.lastName }}</p>
            <p>{{ user.email }}</p>
          </li>
          <li class="dropdown-menu__item">
            <router-link class="dropdown-item" to="/admin/profile">
              <span class="dropdown-menu__item__icon">
                <i class="fa fa-user"></i>
              </span>
              الصفحة الشخصية</router-link
            >
          </li>
          <li class="dropdown-menu__item">
            <a class="dropdown-item" @click="logout" href="#">
              <span class="dropdown-menu__item__icon">
                <img src="../assets/login-icon/logout.svg" alt="logout" />
              </span>
              تسجيل الخروج</a
            >
          </li>
        </ul>
      </div>
    </div>
    <ul class="aside__menu">
      <li class="nav-item" v-if="hasPermission('dashboard')">
        <router-link class="nav-link" to="/admin/dashboard">
          <img src="../assets/login-icon/house.svg" alt="Home" />
          الرئيسية</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('categories')">
        <router-link class="nav-link" to="/admin/categories">
          <img src="../assets/login-icon/circle-nodes-solid.svg" alt="Home" />
          التصنيفات</router-link
        >
      </li>
      <!-- Education -->
      <li
        class="nav-item"
        v-if="
          hasPermission('lessons') ||
          hasPermission('exams') ||
          hasPermission('reviews') ||
          hasPermission('images')
        "
      >
        <button
          class="nav-link dropdown-btn collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#LessonsDropdown"
          aria-expanded="false"
          aria-controls="LessonsDropdown"
        >
          <img src="../assets/login-icon/chalkboard.svg" alt="lessons" />
          الوسائل التعليمية
          <i class="fa fa-chevron-left right icon"></i>
        </button>
        <ul
          id="LessonsDropdown"
          class="dropdown-container nav-treeview collapse"
        >
          <li class="nav-item" v-if="hasPermission('lessons')">
            <router-link class="nav-link" to="/admin/lessons">
              <img src="../assets/login-icon/circle.svg" alt="Lessons" />
              الدروس</router-link
            >
          </li>
          <li class="nav-item" v-if="hasPermission('exams')">
            <router-link class="nav-link" to="/admin/exams">
              <img src="../assets/login-icon/circle.svg" alt="exams" />

              الاختبارات</router-link
            >
          </li>
          <li class="nav-item" v-if="hasPermission('reviews')">
            <router-link class="nav-link" to="/admin/reviews">
              <img src="../assets/login-icon/circle.svg" alt="reviews" />

              المذكرات والمرجعات</router-link
            >
          </li>
          <li class="nav-item" v-if="hasPermission('images')">
            <router-link class="nav-link" to="/admin/images">
              <img src="../assets/login-icon/circle.svg" alt="infograph" />

              الصور التوضيحية</router-link
            >
          </li>
        </ul>
      </li>

      <!-- Posts -->
      <li
        class="nav-item"
        v-if="hasPermission('posts') || hasPermission('informations')"
      >
        <button
          class="nav-link dropdown-btn collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#NewspaperDropdown"
          aria-expanded="false"
          aria-controls="NewspaperDropdown"
        >
          <img src="../assets/login-icon/newspaper-solid.svg" alt="Codes" />
          المنشورات
          <i class="fa fa-chevron-left icon"></i>
        </button>
        <ul
          id="NewspaperDropdown"
          class="dropdown-container nav-treeview collapse"
        >
          <li class="nav-item" v-if="hasPermission('posts')">
            <router-link class="nav-link" to="/posts">
              <img src="../assets/login-icon/circle.svg" alt="posts" />
              الاخبار</router-link
            >
          </li>
          <li class="nav-item" v-if="hasPermission('informations')">
            <router-link class="nav-link" to="/informations">
              <img src="../assets/login-icon/circle.svg" alt="informations" />
              ثقف نفسك</router-link
            >
          </li>
        </ul>
      </li>

      <!-- Students -->
      <li
        class="nav-item d-none-collapsed"
        v-if="
          hasPermission('classes') ||
          hasPermission('groups') ||
          hasPermission('students') ||
          hasPermission('users') ||
          hasPermission('codes') ||
          hasPermission('admins')
        "
      >
        <span>الطلاب</span>
      </li>

      <li class="nav-item" v-if="hasPermission('classes')">
        <router-link class="nav-link" to="/classes">
          <img src="../assets/login-icon/school-solid.svg" alt="classes" />
          الفصول</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('groups')">
        <router-link class="nav-link" to="/groups">
          <img src="../assets/login-icon/people-group-solid.svg" alt="groups" />
          المجموعات</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('students')">
        <router-link class="nav-link" to="/students">
          <img
            src="../assets/login-icon/graduation-cap-solid.svg"
            alt="Students"
          />
          الطلاب</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('users')">
        <router-link class="nav-link" to="/users">
          <img src="../assets/login-icon/users-solid.svg" alt="Users" />
          المستخدمين</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('admins')">
        <router-link class="nav-link" to="/admins">
          <img src="../assets/login-icon/users-solid.svg" alt="Admins" />
          المشرفين</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('codes')">
        <router-link class="nav-link" to="/codes">
          <img src="../assets/login-icon/code.svg" alt="Codes" />
          الاكواد</router-link
        >
      </li>

      <!-- Students -->
      <li
        class="nav-item d-none-collapsed"
        v-if="
          hasPermission('banners') ||
          hasPermission('offers') ||
          hasPermission('contact')
        "
      >
        <span>كسب الجمهور</span>
      </li>

      <li class="nav-item" v-if="hasPermission('banners')">
        <router-link class="nav-link" to="/banners">
          <img src="../assets/login-icon/rectangle-ad-solid.svg" alt="ad" />
          الاعلانات</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('offers')">
        <router-link class="nav-link" to="/offers">
          <img src="../assets/login-icon/percent.svg" alt="Offers" />

          العروض</router-link
        >
      </li>
      <li class="nav-item" v-if="hasPermission('contact')">
        <router-link class="nav-link" to="/contact-us">
          <img src="../assets/login-icon/headset.svg" alt="contact-us" />
          اتصل بنا</router-link
        >
      </li>
    </ul>
  </aside>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { useRouter } from "vue-router";
const router = useRouter();
const isLoggined = ref(false);
let auth;
onMounted(() => {
  auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      isLoggined.value = true;
    } else {
      isLoggined.value = false;
    }
  });
});
const logout = () => {
  signOut(auth).then(() => {
    router.push("/");
  });
};
</script>

<script>
export default {
  data() {
    return {
      settings: {
        suppressScrollY: true,
        suppressScrollX: true,
        wheelPropagation: true,
      },
    };
  },
  props: ["user"],
  methods: {},
  async created() {},

  computed: {},

  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "../scss/abstracts/_mixins.scss";
@import "../scss/abstracts/_variables.scss";
.aside {
  position: fixed;
  width: var(--aside-width);
  height: 100vh;
  right: 0;
  top: 0;
  background-color: var(--aside-bg);
  transition: width var(--transition-slow), background-color var(--transition);
  overflow-y: auto;
  box-shadow: var(--shadow-lg) !important;
  z-index: 999;
  @include flex($direction: column, $justify: flex-start, $align: flex-start);
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--aside-scrollbar-background);
    border-radius: var(--radius-pill);
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }

  // logo
  &__logo {
    @include flex($direction: row, $justify: space-between, $align: center);
    width: 100%;
    padding: var(--space-7) 0.1rem var(--space-5);
    background-color: var(--aside-bg);
    .img_circle {
      $circle: 50px;
      position: relative;
      display: flex;
      align-items: center;
      width: $circle;
      height: $circle;
      margin-left: 1.4rem;
      img {
        width: $circle;
        height: $circle;
        border-radius: 50%;
        overflow: hidden;
        margin: auto;
        background-color: var(--neutral-200);
      }
    }
    h2 {
      color: var(--aside-text-strong);
      font-size: var(--normal-font-size);
      font-weight: 600;
      margin-top: 10px;
      @include nowarp;
    }
    .dropdown-toggle {
      padding: 0;
      width: 30px;
      height: 30px;
      margin: 0 20px 0 10px;
      background: var(--neutral-200);
      border-radius: 50%;
      @include flex($direction: row, $justify: center, $align: center);
      box-shadow: none;
      &::after {
        content: none;
      }
    }
    .dropdown-menu {
      padding: 0;
      border-radius: 5px;
      width: 200px;
      overflow: hidden;
      &__head {
        background-color: var(--aside-bg);
        color: var(--aside-text-strong);
        text-align: right;
        padding: 10px 20px;
        border-bottom: 1px solid var(--aside-border);
        p {
          margin-bottom: 0;
        }
      }
      &__item {
        border-bottom: 1px solid var(--border-subtle);
        text-align: right;
        &:last-child {
          border-bottom: none;
        }
        a {
          color: var(--text-primary);
          padding: 10px 20px;
          font-size: var(--small-font-size);
          font-weight: 600;
          text-decoration: none;
          transition: all 0.4s ease-in-out;
          &:hover {
            color: var(--text-on-brand);
            background-color: var(--brand);
            span {
              svg {
                color: var(--text-on-brand);
              }
              img {
                filter: invert(1);
              }
            }
          }
          span {
            width: 20px;
            padding: 10px 5px;
            svg,
            img {
              transition: all 0.4s ease-in-out;
            }
            svg {
              color: var(--main-color);
            }
            img {
              width: 13px;
              filter: invert(39%) sepia(7%) saturate(3586%) hue-rotate(170deg)
                brightness(89%) contrast(83%);
            }
          }
        }
      }
    }
  }

  // Aside List
  &__menu {
    padding: 0;
    margin: 0;
    margin-bottom: 40px;
    width: 100%;
    > .nav-item {
      > .nav-link {
        position: relative;
        background-color: var(--aside-bg);
        z-index: 5;
        &:focus {
          background-color: var(--aside-bg-hover);
          color: var(--aside-text-strong);
        }
      }
    }
    .nav-link {
      @include flex($direction: row, $justify: flex-start, $align: center);
      padding: 0.6rem 0.85rem;
      margin: 2px var(--space-2);
      border-radius: var(--radius-sm);
      position: relative;
      color: var(--aside-text);
      font-weight: var(--font-medium);
      @include nowarp;
      transition: background-color var(--transition), color var(--transition);
      &:hover {
        color: var(--aside-text-strong);
        background-color: var(--aside-bg-hover);
        img {
          filter: invert(1);
        }
      }
      img {
        margin-left: 1rem;
        margin-right: 0.2rem;
        width: 1.4rem;
        transition: all 0.4s ease-in-out;
        user-select: none;

        filter: invert(97%) sepia(1%) saturate(2351%) hue-rotate(179deg)
          brightness(90%) contrast(88%);
      }
      p {
        display: inline-block;
        margin: 0;
        @include nowarp;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;
      }
    }
    .router-link-exact-active {
      background-color: var(--aside-item-active-background) !important;
      color: var(--aside-item-active-color);
      font-weight: var(--font-semi-bold);
      img {
        filter: invert(1);
      }
      &:hover {
        background-color: var(--aside-item-active-background) !important;
        color: var(--aside-item-active-color);
        img {
          filter: invert(1);
        }
      }
      &:focus {
        color: var(--aside-item-active-color) !important;
      }
    }
    .nav-treeview {
      position: relative;
      z-index: 4;
      background-color: rgba(255, 255, 255, 0.05);
      .nav-item {
        position: relative;

        &:hover {
          &::before {
            background-color: rgba($color: #fff, $alpha: 0.8);
          }
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          width: 0.2rem;
          background-color: rgba($color: #fff, $alpha: 0.7);
        }
        .nav-link {
          img {
            width: 1.3rem;
          }
        }
      }
    }
    > li {
      overflow: hidden;

      span {
        display: inline-block;
        color: var(--aside-section-text);
        font-size: var(--smaller-font-size);
        font-weight: var(--font-semi-bold);
        letter-spacing: 0.05em;
        margin: 0.5rem 0.7rem;
        margin-top: 10px;
        margin-bottom: 5px;
        @include nowarp;
      }

      a,
      button {
        background-color: transparent;
        border: none;
        color: var(--aside-text);
        &:hover {
          background-color: var(--aside-bg-hover);
          color: var(--aside-text-strong);
        }
      }
    }

    .dropdown-btn {
      @include flex($direction: row, $justify: flex-start, $align: center);
      width: -webkit-fill-available;
      &:not(.collapsed) {
        .icon {
          animation: rotateMins 0.3s ease-in;
          animation-fill-mode: forwards;
        }
      }
      .icon {
        animation: rotatePlus 0.3s ease-in;
        animation-fill-mode: forwards;
        margin-right: auto;
      }
    }
    .dropdown-container {
      // display: none;
      position: relative;
      padding: 0;
      transition: all 0.4s ease-in-out;
      z-index: 2;
      background: rgba(255, 255, 255, 0.04);
    }

    @keyframes rotateMins {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(-90deg);
      }
    }
    @keyframes rotatePlus {
      from {
        transform: rotate(-90deg);
      }
      to {
        transform: rotate(0);
      }
    }
  }
}
</style>
